import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplateNoFRWG = ({ albumFolder }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  return (
    <Fragment>
      <div className="marketing-material-flyer-qrcode-secondary no-wg-join-code">
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: albumFolder.web_app_urls?.all_photos_access_url,
            albumFolder,
          })}
          size={width * 0.25 ?? 500}
        />
      </div>
      <img
        ref={templateRef}
        src={getAsset('/marketing-material/MARKETING_FLYER_GENERAL_3.png')}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplateNoFRWG.propTypes = propTypes;

export default FlyerPrintTemplateNoFRWG;
